import React from 'react';
import ScormDetail from '../../components/ScormDetail';
import Scorms from './Scorms';

const CreateWrapper = (props) => (
  <ScormDetail {...props} actionType="create" />
);
const EditWrapper = (props) => <ScormDetail {...props} actionType="edit" />;

const resource = {
  list: Scorms,
  create: CreateWrapper,
  edit: EditWrapper,
};

export default resource;